import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getSubscriptionPackages } from "../api/apiFunctions";

export default function SubscriptionPackages({ selectedId, onSelect }) {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await getSubscriptionPackages();
        console.log("subs packages", response);
        if (response.subscriptions) {
          setPackages(response.subscriptions);
        } else {
          setPackages([]);
        }
      } catch (error) {
        console.error("Failed to fetch packages", error);
        toast.error("Failed to load subscription packages.");
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2d348f]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-4xl border border-[#e5e7eb]">
        <h2 className="md:text-3xl text-xl font-extrabold text-[#2d348f] mb-6 text-center">
          Choose a Subscription Package
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {packages.map((pkg) => (
            <button
              key={pkg._id}
              onClick={() => onSelect(pkg._id)}
              className={`flex flex-col items-start p-6 rounded-2xl border-2 transition-all shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#4962d8]/30 cursor-pointer ${
                selectedId === pkg._id
                  ? "border-[#445eed] bg-[#f5f7ff]"
                  : "border-gray-200 bg-white"
              }`}
            >
              <div className="flex items-center mb-2 w-full justify-between">
                <span className="text-lg font-bold text-[#2d348f] mr-2 text-left">
                  {pkg.name}
                </span>
                <span className="text-base font-semibold text-[#445eed] whitespace-nowrap">
                  ${pkg.price}
                </span>
              </div>
              <p className="text-sm text-[#837f90] mb-2 text-left">
                {pkg.description}
              </p>
              <span className="text-xs text-[#4962d8] font-medium mt-auto">
                {pkg.durationInMonths === 1
                  ? "Monthly"
                  : pkg.durationInMonths === 12
                    ? "Yearly"
                    : `${pkg.durationInMonths} Months`}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
